import { render, staticRenderFns } from "./NewDetails.vue?vue&type=template&id=0dcb5f2c&scoped=true&"
import script from "./NewDetails.vue?vue&type=script&lang=js&"
export * from "./NewDetails.vue?vue&type=script&lang=js&"
import style0 from "./NewDetails.vue?vue&type=style&index=0&id=0dcb5f2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcb5f2c",
  null
  
)

export default component.exports